import City from "../../Models/City";
import {ValueType} from "../../Models/ValueType";

export const GET_CITIES = "City/getCities";
export const DELETE_CITY = "City/deleteCity";
export const SAVE_CITY = "City/saveCity";

export interface CityReducerType {
  cities: City[],
  cityOptionList: ValueType[] ;
}

export interface SearchCityParams {
  name?:string,
  allow_city?:boolean
}
